module.exports = __webpack_public_path__ + "static/HomePage-Best-Selling-GIF-4a93f2b995384956533c29263a21c1a1.gif";